/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-02-12 09:31:33
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-02-20 11:47:20
 * @FilePath: \szsc_ipark_device_admin(contractadmin)\src\index-page\store\invoiceRouter.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import pay from './pay.js'
const ladyLoading = url => () => import(`../views/${url}.vue`)

// 待办列表页面
const handlingPage = ladyLoading('handlingPage/index')
const handlePage = ladyLoading('handlingPage/indexPage')

// 待办详情页面
const handleInfo = ladyLoading('handlingPage/baseInfo/todoDetail')

const Empty = () => import(`@core/router/Empty.vue`)

const routes = {
  path: 'indexPage',
  name: 'indexPage',
  component: Empty,
  // redirect: 'checkin',
  meta: {
    menuId: 'contract0321',
    zhname: '待办列表',
    type: 'menu',
    icon: 'bill',
    aside: true,
    sort: 16
  },
  children: [
    {
      path: 'handlingPage',
      name: 'handlingPage',
      component: handlingPage,
      children: [],
      meta: {
        menuId: 'contract0321001',
        adminMenuId: 'contract0321001',
        type: 'menu',
        zhname: '待办列表',
        icon: 'businessBillList'
      }
    },
    {
      path: 'handleInfo',
      name: 'handleInfo',
      component: handleInfo,
      children: [],
      meta: {
        menuId: 'contract0321002',
        adminMenuId: 'contract0321002',
        type: 'menu',
        zhname: '办理详情',
        icon: 'businessBillList'
      }
    },
    {
      path: 'handlePage',
      name: 'handlePage',
      component: handlePage,
      children: [],
      meta: {
        menuId: 'contract0321003',
        adminMenuId: 'contract0321003',
        type: 'menu',
        zhname: '已办列表',
        icon: 'businessBillList'
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/area-index-page/router/worfklowIndexRouter.js